import React from 'react';
import Icon from 'Components/Icon';
import PropTypes from 'prop-types';
import { classnames } from 'Utils/classnames';

const ToastMessage = ({ className, children, type, icon, rightText, rightClickAction }) => {

  const theme = classnames({
    'Toastify__toast-body': true,
    'Toastify__toast-body__message': true,
    [className]: true,
  });

  let iconName;

  switch (type) {

    case 'success': {
      iconName = 'svgInfoWhite';
      break;
    }

    case 'info': {
      iconName = 'svgInfoWhite';
      break;
    }

    case 'error': {
      iconName = 'svgWarningWhite';
      break;
    }
    case 'show': {
      iconName = 'svgShow';
      break;
    }

    case 'hide': {
      iconName = 'svgHide';
      break;
    }

    case 'openComment': {
      iconName = 'svgOpenComment';
      break;
    }

    case 'nicknameUpdate': {
      iconName = 'svgTribunOrange';
      break;
    }

    case 'closeComment': {
      iconName = 'svgCloseComment';
      break;
    }

    case 'share': {
      iconName = 'svgLinkCopied';
      break;
    }

    case 'pin': {
      iconName = 'svgPin';
      break;
    }

    default: {
      iconName = 'svgInfoWhite';
    }
  }

  return <div className={ theme }>
    <Icon className="Toastify__toast-body__message__left-icon" iconName={ icon || iconName } />
    <div className="Toastify__toast-body__message__text">
      { children }
    </div>

    { /* <div className="Toastify__close-button" /> */ }
    { rightText ? <div className="Toastify__close-text" onClick={ () => rightClickAction() }> { rightText } </div>
      : <div className="Toastify__close-text">Kapat</div> }
    

  </div>;
};

ToastMessage.defaultProps = {
  type: 'success',
  children: 'Bu bir toast.',
  icon: null,
  className: null,
  rightClickAction: () => {},
  rightText: null
};

ToastMessage.propTypes = {
  type: PropTypes.string,
  children: PropTypes.any,
  icon: PropTypes.string,
  className: PropTypes.string,
  rightClickAction: PropTypes.func,
  rightText: PropTypes.string,
};

export default ToastMessage;
